// extracted by mini-css-extract-plugin
export default {"shareBtn":"SharePanel_shareBtn__d2H4F"};